// src/screens/Customer/Customer.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Customer.css";
import { getCustomerById, getCustomerLapTimes } from "../../services/customerService";
import DriverImg from "../../components/images/driver.jpg"; // Import driver image

export default function Customer({ drivers }) {
  const { id } = useParams();
  const [customerData, setCustomerData] = useState(null);
  const [lapTimes, setLapTimes] = useState([]);

  // Find the driver data based on the ID from the URL params
  const driver = drivers.find((d) => d.id === id);

  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const data = await getCustomerById(id);
        setCustomerData(data);
        const laps = await getCustomerLapTimes(id);
        setLapTimes(laps);
      } catch (error) {
        console.error("Error fetching customer data:", error);
      }
    };
    fetchCustomerData();
  }, [id]);

  return (
    <div className="customer-container">
      {customerData && (
        <div>
          <br />
          <h1>{customerData.name}</h1>

          {/* Driver Card */}
          <div className="driver-card-holder">
            <div className="card">
              <img className="card-img-top" src={DriverImg} alt="Driver" />
              <div className="card-body">
                <div className="card-title h5 text-center">{customerData.name}</div>
                <div className="row">
                  <div className="col-6">
                    <div className="text-value">{driver?.driverClass}</div>
                    <small className="text-uppercase text-muted">Driver Class</small>
                    <div className="text-value">{customerData.lastCircuit}</div>
                    <small className="text-uppercase text-muted">Last Circuit</small>
                  </div>
                  <div className="col-6">
                    <div className="text-value">{customerData.lapsRecorded}</div>
                    <small className="text-uppercase text-muted">Laps Recorded</small>
                    <div className="text-value">{customerData.lastVehicle}</div>
                    <small className="text-uppercase text-muted">Last Vehicle</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Lap Times Table */}
          <table className="customer-lap-table">
            <thead>
              <tr>
                <th>Circuit</th>
                <th>Vehicle</th>
                <th>Date</th>
                <th>Time</th>
                <th></th> {/* Telemetry link */}
                <th>S1</th>
                <th>S2</th>
                <th>S3</th>
              </tr>
            </thead>
            <tbody>
              {lapTimes.map((lap, index) => (
                <tr key={index}>
                  <td>{lap.circuit_name}</td>
                  <td>{lap.vehicle_name}</td>
                  <td>{new Date(lap.date).toLocaleDateString("en-US")}</td>
                  <td>{lap.lap_time_str}</td>
                  <td>
                    <a href={lap.telemetry_uri} target="_blank" rel="noopener noreferrer">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="chart-line"
                        className="svg-inline--fa fa-chart-line fa-w-16"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
                        ></path>
                      </svg>
                    </a>
                  </td>
                  <td>{lap.split1_str}</td>
                  <td>{lap.split2_str}</td>
                  <td>{lap.split3_str}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
